// toastOptions.js
import { Flip, Slide } from "react-toastify";

// 기본 옵션
export const DefaultToastOptions = {
  position: "top-center",
  autoClose: 2000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  transition: Flip,
  progress: undefined,
};

// 하단 노티 토스트 옵션
export const NotificationToastOptions = {
  position: "bottom-right",
  autoClose: 3000,
  hideProgressBar: false,
  newestOnTop: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  transition: Slide,
};
